declare var kakao: any;

export class KakaoGeocoder {

    static addressSearch(keyword: any): Promise<any> {

        return new Promise<any>((resolve, reject) => {

            if (!kakao) {
                reject('[kakao] 모듈이 초기화 되지 않았습니다.');
            }

            if (!kakao?.maps?.services?.Geocoder) {
                reject('[kakao.maps.services.Geocoder] 서비스를 찾을 수 없습니다.');
            }

            var geocoder: any = new kakao.maps.services.Geocoder();

            geocoder.addressSearch(keyword, (result: any, status: any) => {
                if (status === kakao.maps.services.Status.OK) {
                    resolve(result);
                } else if (status === kakao.maps.services.Status.ZERO_RESULT) {
                    resolve([]);
                } else {
                    // kakao.maps.services.Status.ERROR
                    reject('[kakao addressSearch] 호출을 실패했습니다.');
                }
            });
        })
    }

    /**
     * 
     * @param x = x 좌표, 경위도인 경우 longitude
     * @param y = y 좌표, 경위도인 경우 latitude
     * @returns 
     */
    static coord2Address(x: any, y: any): Promise<any> {

        return new Promise<any>((resolve, reject) => {

            if (!kakao) {
                reject('[kakao] 모듈이 초기화 되지 않았습니다.');
            }

            if (!kakao?.maps?.services?.Geocoder) {
                reject('[kakao.maps.services.Geocoder] 서비스를 찾을 수 없습니다.');
            }

            var geocoder: any = new kakao.maps.services.Geocoder();

            geocoder.coord2Address(x, y, (result: any, status: any) => {

                if (status === kakao.maps.services.Status.OK) {
                    resolve(result);
                } else if (status === kakao.maps.services.Status.ZERO_RESULT) {
                    resolve([]);
                } else {
                    reject('[kakao coord2Address] 호출을 실패했습니다.');
                }
            });

        })


    }

}